"use client"; 

import { useState } from "react";

import AppActionsSelectorBox from "./appActionsSelectorBox";


export default function AppActionsBlock(
  { app, connection, appConnectionActions, translations }
) {

  if (!(app?.slug || connection?.slug)) return null 
  
  const triggers = appConnectionActions?.triggers 
  const actions = appConnectionActions?.actions

  const [selectedTrigger, setSelectedTrigger] = useState(undefined)
  const [selectedAction, setSelectedAction] = useState(undefined)
  
  const [appAInitial, appBInitial] = [app, connection]?.map(({ 
    id, name, slug, image_updated_at, ...rest 
  }) => ({ 
    id, name, slug, image_updated_at 
  }))

  
  const [appA, setAppA] = useState(appAInitial)
  const [appB, setAppB] = useState(appBInitial)

  // AppA и AppB сделать контроль тут и предавать 
  
  return (
    <>
      {/* {(selectedTrigger && selectedAction) ? (
        <div>
          <p>selectedTrigger SLug: {selectedTrigger?.slug}</p>
          <p>var1: {`${selectedAction.slug}-with-${connection.slug}-on-${selectedTrigger?.slug}-in-${app?.slug}`}</p>
          <p>var2: {`${selectedAction.slug}-in-${connection.slug}-when-${selectedTrigger?.slug}-in-${app?.slug}`}</p>
        </div>
      ) : null} */}


      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-8">
        <AppActionsSelectorBox 
          appA={appA} 
          appB={appB} 
          setAppA={setAppA}
          setAppB={setAppB}
          actions={triggers} 
          type="triggers" 
          selected={selectedTrigger} 
          setSelected={setSelectedTrigger} 
          translations={translations.actionBlock.triggers}
        />
        <AppActionsSelectorBox 
          appA={appA} 
          appB={appB} 
          setAppA={setAppA}
          setAppB={setAppB}          
          actions={actions} 
          type="actions" 
          selected={selectedAction} 
          setSelected={setSelectedAction}  
          translations={translations.actionBlock.actions}
        />
      </div>
    </>

  )
}

